import Link from "next/link";

export type SecondaryButtonProps = {
  text: string;
  navigateTo?: string;
  target?: string;
  className?: string;
  onClick?: () => void;
};

export const TertiaryButton = ({
  text,
  navigateTo,
  target = "_self",
  className = "",
  onClick,
}: SecondaryButtonProps) => {
  const baseClasses =
    "bg-transparent text-primary text-sm lg:text-base uppercase px-2 lg:px-6 py-2 lg:py-4 border border-primary hover:bg-white hover:text-accent transition-all duration-300 w-fit";

  const buttonClasses = `${baseClasses} ${className}`;

  if (navigateTo) {
    return (
      <Link
        href={navigateTo}
        className={buttonClasses}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
        onClick={onClick}
      >
        {text}
      </Link>
    );
  }

  return (
    <button className={buttonClasses} onClick={onClick}>
      {text}
    </button>
  );
};
